import { useEffect } from "react";
import { useSiteSection } from "@/hooks/useSiteContent";
import { isHuggyReady, pushHuggyContext } from "@/lib/huggy";

/**
 * Chat de atendimento Huggy (IDs configuráveis em /admin → Integrações).
 *
 * O jeito certo de instalar (confirmado no código de instalação oficial do
 * painel Huggy, não é `Huggy.init(...)`): definir as variáveis globais
 * `window.$_Huggy` e `window.pwz` ANTES de carregar o script — ele lê essas
 * duas ao inicializar sozinho. Não existe callback de "pronto" documentado
 * pra esse modo, então segue com o polling em `isHuggyReady()`.
 */
export function HuggyChat() {
  const { huggyWidgetId, huggyCompany, huggyContextId } = useSiteSection("integrations");

  useEffect(() => {
    if (!huggyWidgetId) return;
    if (document.getElementById("huggy-chat-script")) return;

    const w = window as unknown as Record<string, unknown>;
    w.$_Huggy = {
      defaultCountry: "+55",
      widget_id: huggyWidgetId,
      company: huggyCompany,
    };
    w.pwz = { context: { id: huggyContextId } };

    const script = document.createElement("script");
    script.id = "huggy-chat-script";
    script.async = true;
    script.src = "https://js.huggy.chat/widget.min.js";
    document.body.appendChild(script);

    let tries = 0;
    const iv = window.setInterval(() => {
      if (isHuggyReady()) {
        pushHuggyContext();
        window.clearInterval(iv);
      } else if (++tries > 50) {
        window.clearInterval(iv); // ~20s: desiste, botões seguem no wa.me
      }
    }, 400);
    return () => window.clearInterval(iv);
  }, [huggyWidgetId, huggyCompany, huggyContextId]);

  return null;
}
